import { useCallback, useEffect, useRef, useState } from "react";

function revogarUrl(url) {
  if (url) {
    window.URL.revokeObjectURL(url);
  }
}

export default function usePreviewAgendamentoPdf() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [blobUrl, setBlobUrl] = useState("");
  const [nomeArquivo, setNomeArquivo] = useState("");
  const blobUrlRef = useRef("");
  const cacheRef = useRef({ key: "", blobUrl: "" });

  const aplicarBlobUrl = useCallback((url, { salvarCache, cacheKey } = {}) => {
    revogarUrl(blobUrlRef.current);
    blobUrlRef.current = url;
    setBlobUrl(url);

    if (salvarCache && cacheKey) {
      revogarUrl(cacheRef.current.blobUrl);
      cacheRef.current = { key: cacheKey, blobUrl: url };
    }
  }, []);

  useEffect(() => {
    return () => {
      revogarUrl(blobUrlRef.current);
      revogarUrl(cacheRef.current.blobUrl);
    };
  }, []);

  const abrirPreview = async ({ cacheKey, nomeArquivo: nome, carregarBlob, usarCache = true }) => {
    setOpen(true);
    setNomeArquivo(nome);

    if (usarCache && cacheRef.current.key === cacheKey && cacheRef.current.blobUrl) {
      aplicarBlobUrl(cacheRef.current.blobUrl);
      setLoading(false);
      return;
    }

    setLoading(true);
    revogarUrl(blobUrlRef.current);
    setBlobUrl("");

    try {
      const blob = await carregarBlob();
      const url = window.URL.createObjectURL(blob);
      aplicarBlobUrl(url, { salvarCache: usarCache, cacheKey });
    } catch (error) {
      setOpen(false);
      setNomeArquivo("");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const fecharPreview = () => {
    setOpen(false);
    setLoading(false);
    setNomeArquivo("");
    revogarUrl(blobUrlRef.current);
    blobUrlRef.current = "";
    setBlobUrl("");
  };

  const invalidarCache = useCallback(() => {
    revogarUrl(cacheRef.current.blobUrl);
    cacheRef.current = { key: "", blobUrl: "" };
    revogarUrl(blobUrlRef.current);
    blobUrlRef.current = "";
    setBlobUrl("");
  }, []);

  return {
    open,
    loading,
    blobUrl,
    nomeArquivo,
    abrirPreview,
    fecharPreview,
    invalidarCache,
  };
}
